import React, { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { INVENTORY_LABTEST_NESTED_ROUTE_DETAIL } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { FETCH_INVENTORY_DASHBOARD } from '../../../shared/constants/urlEndPoints';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { getMappedRoute } from '../../../utils/routeUtility';
import { INVENTROY_CONSTANTS, PACKAGE_TYPE } from './../../../shared/constants/commonConstants';

const LabTest = ({ match }: any): ReactElement => {
  const dispatch = useDispatch();

  const nextDefaultPage = getMappedRoute(match.location?.pathname, INVENTORY_LABTEST_NESTED_ROUTE_DETAIL)
    || INVENTORY_LABTEST_NESTED_ROUTE_DETAIL[0].routeName;

  useEffect((): void => {
    dispatch(dashBoardRequest({
      title: INVENTROY_CONSTANTS.labTests,
      url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: PACKAGE_TYPE.LABTEST,
    }));
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <NestedRoute
        match={match}
        defaultPage={nextDefaultPage}
        nestedNav={INVENTORY_LABTEST_NESTED_ROUTE_DETAIL} />
    </div>
  );
};

export default LabTest;
